/**
 * Nepali (Bikram Sambat) Calendar Utility
 * Reference: BS 2000 Baisakh 1 = AD April 14, 1943
 * Covers BS years 2000–2090 (AD 1943–2033)
 */

// Days in each month for each BS year [Baisakh, Jestha, Ashadh, ...]
const BS_DATA = {
  2000: [30,32,31,32,31,30,30,30,29,30,29,31],
  2001: [31,31,32,31,31,31,30,29,30,29,30,30],
  2002: [31,31,32,32,31,30,30,29,30,29,30,30],
  2003: [31,32,31,32,31,30,30,30,29,29,30,31],
  2004: [30,32,31,32,31,30,30,30,29,30,29,31],
  2005: [31,31,32,31,31,31,30,29,30,29,30,30],
  2006: [31,31,32,32,31,30,30,29,30,29,30,30],
  2007: [31,32,31,32,31,30,30,30,29,29,30,31],
  2008: [31,31,31,32,31,31,29,30,30,29,29,31],
  2009: [31,31,32,31,31,31,30,29,30,29,30,30],
  2010: [31,31,32,32,31,30,30,29,30,29,30,30],
  2011: [31,32,31,32,31,30,30,30,29,29,30,31],
  2012: [31,31,31,32,31,31,29,30,30,29,30,30],
  2013: [31,31,32,31,31,31,30,29,30,29,30,30],
  2014: [31,31,32,32,31,30,30,29,30,29,30,30],
  2015: [31,32,31,32,31,30,30,30,29,29,30,31],
  2016: [31,31,31,32,31,31,29,30,30,29,30,30],
  2017: [31,31,32,31,31,31,30,29,30,29,30,30],
  2018: [31,31,32,32,31,30,30,29,30,29,30,30],
  2019: [31,32,31,32,31,30,30,30,29,29,30,31],
  2020: [31,31,31,32,31,31,29,30,30,29,30,30],
  2021: [31,31,32,31,31,31,30,29,30,29,30,30],
  2022: [31,31,32,32,31,30,30,29,30,29,30,30],
  2023: [31,32,31,32,31,30,30,30,29,29,30,31],
  2024: [31,31,31,32,31,31,29,30,30,29,30,30],
  2025: [31,31,32,31,31,31,30,29,30,29,30,30],
  2026: [31,31,32,32,31,30,30,29,30,29,30,30],
  2027: [31,32,31,32,31,30,30,30,29,29,30,31],
  2028: [31,31,31,32,31,31,29,30,30,29,30,30],
  2029: [31,31,32,31,31,31,30,29,30,29,30,30],
  2030: [31,31,32,32,31,30,30,29,30,29,30,30],
  2031: [31,32,31,32,31,30,30,30,29,29,30,31],
  2032: [31,31,31,32,31,31,29,30,30,29,30,30],
  2033: [31,31,32,31,31,31,30,29,30,29,30,30],
  2034: [31,31,32,32,31,30,30,29,30,29,30,30],
  2035: [31,32,31,32,31,30,30,30,29,29,30,31],
  2036: [31,31,31,32,31,31,29,30,30,29,30,30],
  2037: [31,31,32,31,31,31,30,29,30,29,30,30],
  2038: [31,31,32,32,31,30,30,29,30,29,30,30],
  2039: [31,32,31,32,31,30,30,30,29,29,30,31],
  2040: [31,31,31,32,31,31,29,30,30,29,30,30],
  2041: [31,31,32,31,31,31,30,29,30,29,30,30],
  2042: [31,31,32,32,31,30,30,29,30,29,30,30],
  2043: [31,32,31,32,31,30,30,30,29,29,30,31],
  2044: [31,31,31,32,31,31,29,30,30,29,30,30],
  2045: [31,31,32,31,31,31,30,29,30,29,30,30],
  2046: [31,31,32,32,31,30,30,29,30,29,30,30],
  2047: [31,32,31,32,31,30,30,30,29,29,30,31],
  2048: [31,31,31,32,31,31,29,30,30,29,30,30],
  2049: [31,31,32,31,31,31,30,29,30,29,30,30],
  2050: [31,31,32,32,31,30,30,29,30,29,30,30],
  2051: [31,32,31,32,31,30,30,30,29,29,30,31],
  2052: [31,31,31,32,31,31,29,30,30,29,30,30],
  2053: [31,31,32,31,31,31,30,29,30,29,30,30],
  2054: [31,31,32,32,31,30,30,29,30,29,30,30],
  2055: [31,32,31,32,31,30,30,30,29,29,30,31],
  2056: [31,31,31,32,31,31,29,30,30,29,30,30],
  2057: [31,31,32,31,31,31,30,29,30,29,30,30],
  2058: [31,31,32,32,31,30,30,29,30,29,30,30],
  2059: [31,32,31,32,31,30,30,30,29,29,30,31],
  2060: [31,31,31,32,31,31,29,30,30,29,30,30],
  2061: [31,31,32,31,31,31,30,29,30,29,30,30],
  2062: [31,31,32,32,31,30,30,29,30,29,30,30],
  2063: [31,32,31,32,31,30,30,30,29,29,30,31],
  2064: [31,31,31,32,31,31,29,30,30,29,30,30],
  2065: [31,31,32,31,31,31,30,29,30,29,30,30],
  2066: [31,31,32,32,31,30,30,29,30,29,30,30],
  2067: [31,32,31,32,31,30,30,30,29,29,30,31],
  2068: [31,31,31,32,31,31,29,30,30,29,30,30],
  2069: [31,31,32,31,31,31,30,29,30,29,30,30],
  2070: [31,31,32,32,31,30,30,29,30,29,30,30],
  2071: [31,32,31,32,31,30,30,30,29,29,30,31],
  2072: [31,31,31,32,31,31,29,30,30,29,30,30],
  2073: [31,31,32,31,31,31,30,29,30,29,30,30],
  2074: [31,31,32,32,31,30,30,29,30,29,30,30],
  2075: [31,32,31,32,31,30,30,30,29,29,30,31],
  2076: [31,31,31,32,31,31,29,30,30,29,30,30],
  2077: [31,31,32,31,31,31,30,29,30,29,30,30],
  2078: [31,31,32,32,31,30,30,29,30,29,30,30],
  2079: [31,32,31,32,31,30,30,30,29,29,30,31],
  2080: [31,31,31,32,31,31,29,30,30,29,30,30],
  2081: [31,31,32,31,31,31,30,29,30,29,30,30],
  2082: [31,31,32,32,31,30,30,29,30,29,30,30],
  2083: [31,32,31,32,31,30,30,30,29,29,30,31],
  2084: [31,31,31,32,31,31,29,30,30,29,30,30],
  2085: [31,31,32,31,31,31,30,29,30,29,30,30],
  2086: [31,31,32,32,31,30,30,29,30,29,30,30],
  2087: [31,32,31,32,31,30,30,30,29,29,30,31],
  2088: [31,31,31,32,31,31,29,30,30,29,30,30],
  2089: [31,31,32,31,31,31,30,29,30,29,30,30],
  2090: [31,31,32,32,31,30,30,29,30,29,30,30],
};

export function getDaysInBSMonth(year, month) {
  return BS_DATA[year] ? BS_DATA[year][month] : 30;
}

export const NEPALI_MONTHS = [
  'Baisakh','Jestha','Ashadh','Shrawan',
  'Bhadra','Ashwin','Kartik','Mangsir',
  'Poush','Magh','Falgun','Chaitra'
];

export const NEPALI_MONTHS_SHORT = [
  'Bai','Jes','Ash','Shr','Bha','Ash','Kar','Man','Pou','Mag','Fal','Cha'
];

// Reference: BS 2000 Baisakh 1 = AD April 14, 1943
const REF_AD = new Date(1943, 3, 14);

/**
 * Convert an AD date to Bikram Sambat (BS)
 * @param {Date|string} adDate
 * @returns {{ year, month, day } | null}  month is 0-indexed (0 = Baisakh)
 */
export function adToBS(adDate) {
  if (!adDate) return null;
  const d = new Date(adDate);
  if (isNaN(d.getTime())) return null;

  // Normalise to midnight to avoid DST / timezone drift
  const input = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const ref   = new Date(REF_AD.getFullYear(), REF_AD.getMonth(), REF_AD.getDate());

  let days = Math.round((input - ref) / 86400000);
  if (days < 0) return null;

  let year = 2000;

  // Step through BS years
  while (BS_DATA[year]) {
    const daysInYear = BS_DATA[year].reduce((a, b) => a + b, 0);
    if (days < daysInYear) break;
    days -= daysInYear;
    year++;
  }

  if (!BS_DATA[year]) return null;

  // Step through months
  let month = 0;
  let day = 1;
  for (let m = 0; m < 12; m++) {
    if (days < BS_DATA[year][m]) {
      month = m;
      day   = days + 1;
      break;
    }
    days -= BS_DATA[year][m];
  }

  return { year, month, day };
}

/** BS { year, month (0-indexed), day } → AD Date */
export function bsToAD(bsYear, bsMonth, bsDay) {
  let days = 0;
  for (let y = 2000; y < bsYear; y++) {
    if (!BS_DATA[y]) break;
    days += BS_DATA[y].reduce((a, b) => a + b, 0);
  }
  for (let m = 0; m < bsMonth; m++) {
    days += BS_DATA[bsYear][m];
  }
  days += bsDay - 1;

  const ref    = new Date(1943, 3, 14);
  const result = new Date(ref);
  result.setDate(result.getDate() + days);
  return result;
}

const PLAN_MONTHS_BS = { Monthly: 1, Quarterly: 3, Yearly: 12 };

/**
 * Add N months in BS calendar space.
 * Jestha 17 + 1 BS month = Ashadh 17 (exact same BS day).
 */
export function addBSMonths(adDate, plan) {
  const bs = adToBS(adDate);
  if (!bs) return new Date(adDate);

  const toAdd    = PLAN_MONTHS_BS[plan] || 1;
  let newMonth   = bs.month + toAdd;
  let newYear    = bs.year;
  while (newMonth >= 12) { newMonth -= 12; newYear++; }

  if (!BS_DATA[newYear]) {
    const d = new Date(adDate);
    d.setMonth(d.getMonth() + toAdd);
    return d;
  }

  const daysInTarget = BS_DATA[newYear][newMonth];
  const newDay       = Math.min(bs.day, daysInTarget);
  return bsToAD(newYear, newMonth, newDay);
}

/**
 * Format a date as Nepali BS  →  "Jestha 16, 2083 B.S."
 */
export function formatNepaliDate(adDate) {
  if (!adDate) return '-';
  const bs = adToBS(adDate);
  if (!bs) return '-';
  const day = String(bs.day).padStart(2, '0');
  return `${NEPALI_MONTHS[bs.month]} ${day}, ${bs.year} B.S.`;
}

/**
 * Format as short Nepali date  →  "16 Jes 2083"
 */
export function formatNepaliDateShort(adDate) {
  if (!adDate) return '-';
  const bs = adToBS(adDate);
  if (!bs) return '-';
  return `${bs.day} ${NEPALI_MONTHS_SHORT[bs.month]} ${bs.year}`;
}

/**
 * Days remaining until an AD expiry date, labelled in BS month/year
 * e.g.  "30 days  (until Ashadh 29, 2083 B.S.)"
 */
export function nepaliDaysRemaining(expiryDate) {
  if (!expiryDate) return null;
  const now  = new Date();
  const exp  = new Date(expiryDate);
  const days = Math.ceil((exp - now) / 86400000);
  const bs   = adToBS(exp);
  if (!bs) return { days, label: `${days}d left` };
  return {
    days,
    label: `${days}d left`,
    bsDate: formatNepaliDate(expiryDate),
  };
}
